import { useState, useEffect } from "react";
import { fetchAll } from "../utils/fetchResources";
import { makeStyles } from "@material-ui/core/styles";
import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	TextField,
} from "@material-ui/core";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";

const useStyles = makeStyles((theme) => ({
	form: {
		width: "100%", // Fix IE 11 issue.
	},
	submit: {
		margin: theme.spacing(2, 0, 1),
	},
	fileList: {
		display: "flex",
		flexWrap: "wrap",
		maxHeight: "85vh",
		maxWidth: "85vw",
		overflowY: "auto",
	},
	gridFiles: {
		"&::before": {
			content: "''",
			display: "block",
			paddingTop: "100%",
		},
		width: "33%!important",
		height: "auto!important",
		backgroundSize: "cover!important",
		backgroundPosition: "center center!important",
		backgroundRepeat: "no-repeat!important",
		cursor: "pointer!important",
		padding: ".5rem!important",
	},
}));

function SetFile({
	fileTitle,
	resource,
	setResource,
	imageOnly,
	fileLabel,
	fileLabelFileName,
}) {
	const classes = useStyles();
	const [loading, setLoading] = useState(true);
	const [files, setFiles] = useState();
	const [dialogOpen, setDialogOpen] = useState(false);
	const [searchText, setSearchText] = useState("");

	useEffect(() => {
		const getAllFiles = async () => {
			// Show recently uploaded files first
			await fetchAll("files", setFiles, "-uploadedAt");
			setLoading(false);
		};
		getAllFiles();
	}, []);

	const handleDialogOpen = () => {
		setDialogOpen(true);
	};

	const handleDialogClose = () => {
		setDialogOpen(false);
		//Reset search text to nothing on close
		setSearchText("");
	};

	if (loading) {
		return <div>Loading...</div>;
	}

	return (
		<div>
			<Button
				color="secondary"
				onClick={handleDialogOpen}
				style={{ marginTop: ".5rem" }}
			>
				{resource[fileLabel] ? `Change ${fileTitle}` : `Set ${fileTitle}`}
			</Button>
			{resource[fileLabel] &&
				files
					.filter((file) => file._id === resource[fileLabel])
					.map(function (file, index) {
						if (/^image/.test(file.mime)) {
							return (
								<div
									key={index}
									style={{
										background: "black",
										padding: "1rem",
										margin: "1rem 0",
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										borderRadius: "5px",
									}}
								>
									<img
										alt={file.fileName}
										key={index}
										style={{
											width: "auto",
											maxWidth: "100%",
											maxHeight: "50vh",
										}}
										src={`${process.env.REACT_APP_FILE_URL}/${file.fileName}`}
									/>
								</div>
							);
						} else {
							return (
								<a
									style={{ textDecoration: "none" }}
									key={index}
									href={`${process.env.REACT_APP_FILE_URL}/${file.fileName}`}
									target="_blank"
									rel="noreferrer"
									download
								>
									<div
										style={{
											background: "black",
											padding: "1rem",
											margin: "1rem 0",
											color: "white",
											cursor: "pointer",
											borderRadius: "5px",
											overflowWrap: "break-word",
											wordWrap: "break-word",
											wordBreak: "break-word",
										}}
									>
										{`${file.fileName}`}
									</div>
								</a>
							);
						}
					})}
			<Dialog open={dialogOpen} onClose={handleDialogClose}>
				<DialogTitle>{fileTitle}</DialogTitle>
				<DialogContent style={{ marginBottom: "1rem", minWidth: "600px" }}>
					<TextField
						variant="outlined"
						margin="normal"
						fullWidth
						id="search"
						label="Search Files"
						name="search"
						size="small"
						autoFocus
						style={{ marginTop: 0, marginBottom: "1rem" }}
						onChange={(e) => setSearchText(e.target.value)}
					/>
					<div className={classes.fileList}>
						{files
							.filter((file) => (imageOnly ? /^image/.test(file.mime) : file))
							.filter(
								(file) => file.fileName.indexOf(searchText.toLowerCase()) > -1
							)
							.map((file, index) => (
								<div
									className={classes.gridFiles}
									key={index}
									style={{
										background: file.thumbnailName
											? `url('${process.env.REACT_APP_FILE_URL}/${file.thumbnailName}')`
											: "black",
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										padding: "1rem",
										color: "white",
									}}
									onClick={() => {
										resource[fileLabel] === file._id
											? setResource({
													...resource,
													[fileLabel]: null,
													[fileLabelFileName]: null,
											  })
											: setResource({
													...resource,
													[fileLabel]: file._id,
													[fileLabelFileName]: file.fileName,
											  });
										handleDialogClose();
									}}
								>
									{!file.thumbnailName && (
										<div
											style={{
												display: "flex",
												width: "100%",
												flexDirection: "column",
												justifyContent: "center",
												alignItems: "center",
												overflowY: "auto",
												overflowX: "hidden",
												overflowWrap: "break-word",
												wordWrap: "break-word",
												wordBreak: "break-word",
											}}
										>
											<InsertDriveFileIcon
												style={{ fontSize: "2rem", marginBottom: ".5rem" }}
											/>
											{file.fileName}
										</div>
									)}
								</div>
							))}
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
}

export default SetFile;
